import { hasRole } from "@shelflist/shared";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { adminPageItems } from "@/components/nav/nav-items";
import { NoPermission } from "@/components/no-permission";
import { SectionNav, type SectionNavItem } from "@/components/section-nav";
import { featuresQuery } from "@/lib/metadata";
import { useMe } from "@/lib/session";

/** Layout of the Administration area: admins only (the API enforces the same rule). */
export const Route = createFileRoute("/_app/admin")({
  component: AdminLayout,
});

export function AdminLayout() {
  const me = useMe();
  const { t } = useTranslation("admin");
  const { t: tAll } = useTranslation();
  const features = useQuery(featuresQuery).data;
  if (!hasRole(me, "admin")) return <NoPermission />;
  return (
    <div className="grid gap-6 md:grid-cols-[12rem_minmax(0,1fr)] md:gap-8">
      <SectionNav
        variant="sidebar"
        label={t("area.label")}
        items={adminPageItems(me.role, features).map((item) => ({
          to: item.to as SectionNavItem["to"],
          label: tAll(item.labelKey as never),
          icon: item.icon,
          exact: item.exact,
        }))}
      />
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
